
export const BUTTONS=[
	{
		id:1,
		name:'Easy'
	},
	{
		id:2,
		name:'Normal'
	},
	{
		id:3,
		name:'Hard'
	},
	{
		id:4,
		name:'Expert'
	},
	{
		id:5,
		name:'Professional'
	}
];
export const STARTERS=[
	{
		id:0,
		name:'Human'
	},
	{
		id:1,
		name:'Computer'
	}

];